<template>
  <v-snackbar
    v-model="snackbar.visible"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    class="elevation-4"
    transition="slide-y-reverse-transition"
    rounded
  >
    <div class="d-flex align-center">
      <v-icon left v-if="snackbar.icon">
        {{ snackbar.icon }}
      </v-icon>
      <span>{{ snackbar.text }}</span>
    </div>

    <template v-slot:action="{ attrs }">
      <v-btn icon v-bind="attrs" @click="snackbar.visible = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
import { EventBus } from '../functions/event-bus'

export default {
  data() {
    return {
      snackbar: {
        visible: false,
        text: '',
        color: 'success', // Predeterminado a 'success'
        timeout: 3000     // Duración de la notificación
      }
    };
  },
  created() {
    EventBus.$on('show-snackbar', this.showSnackbar); // Escuchar el evento
  },
  methods: {
    showSnackbar({ text, color = 'success', timeout = 3000 }) {
      this.snackbar = {
        visible: true,
        text,
        color,
        timeout
      };
    }
  }
};
</script>